<template>
  <div class="layout-header">
    <div class="layout-header-top">
      <div class="left">
        <div class="logo">
          <img :src="userinfo.isChangeLogo && userinfo.titleoemurl ? userinfo.titleoemurl : defaultLogo" />
        </div>
        <div class="selectCompany">
          <!-- <companySelect @set-tab="setTab" ref="companySelectRef" /> -->
          <div class="toggle" id="guideToggle">
            <div class="toggle_box">
              <div :class="tabNum == 4 ? 'toggle_btn active' : 'toggle_btn'">
                <span @click="setAmend(4)">客户管理</span>
              </div>
              <!-- <div v-if="isPlatform" :class="tabNum == 1 ? 'toggle_btn active' : 'toggle_btn'">
                <span @click="setAmend(1)">工作台</span>
              </div> -->
              <div v-if="isPlatform" :class="tabNum == 3 ? 'toggle_btn active' : 'toggle_btn'">
                <el-badge :is-dot="approveCount > 0" class="item">
                  <span v-if="isApprove" @click="setAmend(3)">审批中心</span>
                </el-badge>
              </div>
              <div :class="tabNum == 6 ? 'toggle_btn active' : 'toggle_btn'" class="showNew" v-if="isCustomerPower(200100)">
                <span @click="setAmend(6)">财税检测</span>
                <i class="iconfont is_dot" v-if="isShowNew">&#xe6a2;</i>
              </div>
              <div :class="tabNum == 7 ? 'toggle_btn active' : 'toggle_btn'" v-if="isCustomerPower(300001) || isCustomerPower(300002)">
                <span @click="setAmend(7)">订单管理</span>
              </div>
              <div :class="tabNum == 5 ? 'toggle_btn active' : 'toggle_btn'">
                <span @click="setAmend(5)">行业方案模板</span>
              </div>
              <div v-if="isManager" :class="tabNum == 2 ? 'toggle_btn active' : 'toggle_btn'">
                <mangeIcon @tab="setAmend" />
              </div>
              <!-- v-if="userinfo.phone === '15601030881' || userinfo.phone === '18703689370' || userinfo.phone === '16602874392'" -->
              <!-- <div :class="tabNum == 6 ? 'toggle_btn active' : 'toggle_btn'" v-if="agentIdList.includes(userinfo.companyid)">
                <span @click="setAmend(6)">财税检测</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="center"></div>
      <div class="right">
        <notice-index @jump="jump" />
        <logout-icon />
      </div>
    </div>
    <!-- <div class="back" v-if="tabNum == 2"><span @click="setAmend(1)">返回工作台</span></div> -->
  </div>
</template>
<script lang="ts" setup>
import logoutIcon from "./components/logoutIcon.vue";
import mangeIcon from "./components/manageIcon.vue";
import { ref, computed, onMounted, watch, watchPostEffect, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import NoticeIndex from "./notice/noticeIndex.vue";
// import commonApi from "../api/common/commonApi";
import useInitData from "@/hooks/useInitData";
import defaultLogo from "@/assets/logo.svg";
import bus from "@/hooks/useBus";
import { ACCESS } from "@/api/common/commonLimit";
import useIcon from "@/hooks/login/useIcon";
// 权限
import useCustomerPower from "@/utils/isCustomerPower";
const isCustomerPower = useCustomerPower();

const { setTitle, updateFavicon } = useIcon();
const { getCompanyCounter, getCurrentToken } = useInitData();
const store = useStore();
const route = useRoute();
const router = useRouter();
let isManager = computed((): string => store.getters.getUserinfo("isManager"));
let isPlatform = computed((): string => store.getters.getUserinfo("isPlatform"));
const isApprove = computed((): boolean => store.getters.getCurrentPower.isApprove);
const storeCompany = computed(() => store.getters.getThisCompany);
const OEMInfo = ref(computed(() => store.state.common.OEMInfo));
const userinfo = ref(computed(() => store.state.common.userinfo));
const tabNum = computed(() => store.getters.getTabNum);
const badges = computed(() => store.getters.getBadges);
const getTagList = computed(() => store.getters.getTagList);

const agentIdList = ["fb069ed5-0d5d-4db6-82ee-cb0b5d5c7285", "1ed54b93-d078-47aa-b2c4-7a6b5d25fe4f", "875ccdb3-9405-4ed1-81a5-2e89f8ae4450", "46f6dc38-a72a-4f8f-9dc5-47529278bca9", "930b1282-15e7-4f9e-b0c5-5dd303a78881", "caa5c32f-7b35-4d06-9d20-6a92df08b4a5"];

const isShowNew = computed(() => {
  const FutureDay = new Date("2024-02-29");
  const nowDay = new Date();
  if (FutureDay.getTime() > nowDay.getTime()) {
    return true;
  }
  return false;
});
// const isLazy = ref(false);
// const companySelectRef = ref();
//是否有审批权限
//企业列表
const comapnys = ref();
const approveCount = ref(0);
onMounted(async () => {
  //await initData();
  // setTimeout(() => {
  //   isLazy.value = true;
  // }, 500);
  // 新的标题
});
const isReady = ref(false);

watchPostEffect(() => {
  const list = store.getters.getTagList;
  isReady.value = !!list.length;
  console.log(isReady.value, "isReadyisReadyisReadyisReadyisReady", userinfo.value);
  setTitle(userinfo.value.isChangeLogo ? userinfo.value.titlename : "");
  // 新的icon
  updateFavicon(userinfo.value.isChangeLogo ? userinfo.value.oemWebsiteIcon : "");
});
watch(isReady, (bol) => {
  if (bol) getCompanyCounter();
});
const unwatch = watch(getTagList, () => {
  console.log(getTagList.value, "getTabList.value");
  if (getTagList.value[0]) {
    getCurrentToken(getTagList.value[0].companyNumber, ACCESS.ZERO);
    unwatch();
  }
});

watch([badges], () => {
  GetapproveCount(storeCompany.value.companyNumber);
});
const GetapproveCount = (companyNumber: string) => {
  approveCount.value = badges.value?.find((m: { companyNumber: any }) => m.companyNumber == companyNumber)?.list.find((m: { moduleType: string }) => m.moduleType == "sp").count ?? 0;
};
const setAmend = (val: number) => {
  store.dispatch("setCurrentTabNum", val);
  if (val == 1 && isReady.value) router.push({ name: "home", params: { id: route.params.id ?? storeCompany.value.companyNumber } });
  else if (val == 1 && !isReady.value) router.push("/");
  else if (val == 2) router.push({ name: "manage" });
  else if (val == 3 && isReady.value) router.push({ name: "approve", params: { id: route.params.id ?? storeCompany.value.companyNumber } });
  else if (val == 3 && !isReady.value) router.push("/");
  else if (val == 4) router.push({ name: "signedCustomer" });
  else if (val == 5) router.push({ name: "appStore" });
  else if (val == 6) router.push({ name: "inspection" });
  else if (val == 7) router.push({ name: "orderDetail" });
};
//公告提醒,预算点击跳转处理 companyNumber: string, subId: string, data: number, routername: string
const jump = (data: any) => {
  console.log("jump");
  const company = getTagList.value.find((m: { code: string }) => m.code == data.companyNumber);
  // debugger;
  if (data.name == "approve") {
    store.dispatch("setCurrentTabNum", 3);
    const subData = company.itemList[0]; //.find((m: { id: string }) => m.id == subId);
    //向兄弟组件companySelect发送数据
    bus.emit("selectCompany", { val: subData, node: { isLeaf: true }, entryMode: 2, data: data.approve });
    router.push({ name: "approve", params: { id: data.companyNumber, approve: data.approve } });
  } else {
    store.dispatch("setCurrentTabNum", 1);
    const subData = company.itemList.find((m: { id: string }) => m.id == data.subId);
    //向兄弟组件companySelect发送数据
    bus.emit("selectCompany", { val: subData, node: { isLeaf: true }, entryMode: 1 });
  }
};
</script>
<style lang="less">
.back {
  width: 100%;
  position: absolute;
  top: 60px;
  z-index: 1;
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
  background-color: hsl(218, 67%, 98%);
  height: 30px;
  line-height: 30px;
}
.back::before {
  content: "<";
}
.layout-header {
  line-height: 60px;
}
.layout-header-top {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-between;
  & > div {
    flex: 1;
  }
  .center {
    display: flex;
    justify-content: center;
  }
  .right {
    justify-content: flex-end;
  }
  .left,
  .right {
    display: flex;
    align-items: center;

    .btn {
      display: flex;
      align-items: center;
      margin-right: @padding;
    }

    .iconfont {
      font-size: 20px;
    }

    .pointer {
      cursor: pointer;
    }
  }
  .logo {
    display: flex;
    width: @logoWidth;
    height: @logoHeight;
    justify-content: center;
    align-items: center;
    img {
      max-width: @logoWidth;
      max-height: @logoHeight;
      width: 100%;
      height: 100%;
    }
  }
  .toggle {
    // display: flex;
    // height: 30px;
    // // border: 1px solid #455063;
    // border-radius: 7px;
    // font-size: 14px;
    // overflow: hidden;
    // line-height: 30px;
    margin-left: 10px;
    cursor: pointer;
    span {
      cursor: pointer;
      font-size: 16px;
      // font-weight: bolder;
    }
    .active {
      color: #5dade7;
    }
    .toggle_btn {
      cursor: pointer !important;
      margin-right: 37px;
      display: flex;
      align-items: center;
    }
  }
  .selectCompany {
    position: absolute;
    left: @navWidth;
    // width: 50%;
    min-width: 650px;
    display: flex;
    align-items: center;
    .icon {
      transition: transform 0.3s;
    }
    .inputPlaceholder {
      .el-textarea__inner,
      .el-input__inner {
        &::placeholder {
          color: black;
        }
      }
    }
    .toggle {
      width: 100%;
      .toggle_box {
        display: flex;
        align-items: center;
      }
    }
  }
}
.showNew {
  position: relative;
  .is_dot {
    position: absolute;
    font-size: 13px !important;
    top: -5px;
    right: -25px;
    color: #de0b1e;
  }
}
</style>
